var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideshow-models"},[_c('iframe',{attrs:{"src":((_vm.data.acf['3d_model']) + "/embed"),"frameborder":"0","allowvr":"","allowfullscreen":"","mozallowfullscreen":"true","webkitallowfullscreen":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }